const highest = (values) =>
  values.reduce((max, value) => {
    const n = Number(value);
    return Number.isFinite(n) && n > max ? n : max;
  }, 0);

const asList = (switches) => (Array.isArray(switches) ? switches : []);

export const highestAssignedUOS = (switches) =>
  highest(asList(switches).map((each) => each?.UOS));

export const highestAssignedSSR = (switches) =>
  highest(
    asList(switches).flatMap((each) =>
      (Array.isArray(each?.selectedSSR) ? each.selectedSSR : []).flatMap(
        (entry) => Object.keys(entry ?? {}).map((key) => key.replace('ssr', '')),
      ),
    ),
  );
